import {Component, 
    OnInit, 
    ElementRef, 
    ViewChildren, 
    ViewChild, 
    ChangeDetectionStrategy, 
    ChangeDetectorRef, 
    Inject, 
	ViewRef,
	HostListener
} 
from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader, MatOptionSelectionChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { DeNghiNhapKhoService } from '../kho-de-nghi-nhap-kho-page-service/kho-de-nghi-nhap-kho-page.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
//Model
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { TimKiemNangCaoListComponent } from '../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { DeNghiNhapKhoChiTiet, DeNghiNhapKho } from '../kho-de-nghi-nhap-kho-page-model/kho-de-nghi-nhap-kho-page.model';
import { Router, ActivatedRoute } from '@angular/router';
import { DNNKLSNhapKhoDialogComponent } from '../kho-lich-su-nhap-list-dialog/kho-lich-su-nhap-list-dialog.component';

@Component({
	selector: 'm-kho-de-nghi-nhap-kho-add-edit-dialog',
	templateUrl: './kho-de-nghi-nhap-kho-add-edit-dialog.component.html',
	styleUrls: ['../kho-de-nghi-nhap-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class DeNghiNhapKhoAddEditDialogComponent implements OnInit{

	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport : ElementRef;
	@ViewChildren('focusDetail') focusDetail;
	
	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/
    
    /*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 6,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
    ];
	/* ------------------------------------------------------------------*/
	

    /*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------*/
	
	
    /*------------------------ Danh sách trạng thái ----------------------*/
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


    /*------------------------ Danh sách phòng ban -----------------------*/
	listPB : any[] = [];
	PBUser: string = '';   	
	selectPB : string = '';
	filteredPB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	PBFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	/*------------------------ Danh sách bộ phận ----------------------*/
	listBP : any[] = [];
	selectBP : string = '';
	filteredBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	BPFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	/*--------------------- Danh sách Khu vực sản xuất -------------------*/
	listKVSX : any[] = [];
	selectKVSX : string = '';
	filteredKVSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KVSXFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	/*------------------------ Danh sách loại phiếu ----------------------*/
	listLoaiPhieu : any[] = [];
	selectLoaiPhieu : string = '';
	filteredLoaiPhieu: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiPhieuFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	/*------------------ Danh sách giai đoạn hàng hóa---------------------*/
	listGDHH : any[] = [];
	selectGDHH : string = '';
	filteredGDHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	GDHHFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */
	
	
    /* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);
	/* ------------------------------------------------------------------ */


    /* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	DNNKForm: FormGroup;				     //Form thông tin đề nghị nhập kho
	HHForm: FormGroup;			            //Form add hàng hóa cho phiếu	
	ImportHHForm: FormGroup;			    //Form import hàng hóa cho phiếu
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	DNNKItem: DeNghiNhapKho;
	listChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
	tmpChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
	/* ------------------------------------------------------------------ */


    /*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	saveAddedCT: number[] = []	
	viewLoading: boolean = false;   	// Loading khi mở dialog
    disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
    flagTab: number = 0;				// Định danh tab đang chạy
	openTimKiemNangCao = false;
	isCopy: boolean = false;
	fromKQPhongCan: boolean = false;
    /* ------------------------------------------------------------------ */

    constructor(
		public dialogRef: MatDialogRef<DeNghiNhapKhoAddEditDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
        private deNghiNhapKhoService: DeNghiNhapKhoService,
        private dungChungService: DungChungService,
		private DNNKFB: FormBuilder,
		private HHFB: FormBuilder,
		private ImportFB: FormBuilder,
		public dialog: MatDialog,
		private router: Router,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
    ) {
		this.dialogRef.disableClose = true;
	}
    
    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {
		/*Load all dropdown and create form */
		this.ListId_HH();
		this.ListState();
		this.ListLoaiPhieu();
		this.ListPB();
		this.ListBoPhan();
		this.ListGDHH();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.DNNKItem = new DeNghiNhapKho();
		this.DNNKItem.clear();
		this.createForm();
		
		const id = +this.data.Id;
		if(this.data != null && this.data.isCopy){
			this.isCopy = this.data.isCopy;
		}
		if ((id && id > 0) || this.isCopy) {
			this.DNNKItem.IdDn = id;
			this.deNghiNhapKhoService.getItemById(this.DNNKItem.IdDn).subscribe(res => {
				if(res.status == 1){
					this.DNNKItem = res.data
					this.DNNKItem.isCreateQT = true;
					if(res.data.Tinhtrang != DeNghiNhapKho.optionsTinhTrang[0].value && !this.isCopy){
						this.router.navigateByUrl('/404');
					}
					if(this.DNNKForm != null){
						this.bindingValueAfterCallAPIDetail();
					}
				}
			});
		} else {
			this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
			this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
				if (res.status == 1){
					this.DNNKItem.Sophieu = res.data;
					if(this.DNNKForm != null)
						this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
				}
			});

			if(this.data.fromKQPhongCan){
				this.DNNKItem.isCreateQT = false;
				var dataCT = this.data.dataPhongCan;

				const _detail = new DeNghiNhapKhoChiTiet();
				_detail.clear();

				_detail.IdHh = dataCT.HangHoaId;
				_detail.MaHH = dataCT.MaHangCT;
				_detail.TenHH = dataCT.TenHangCT;
				_detail.QuyCach = dataCT.QuyCachCT;
				_detail.TenDVT = dataCT.TenDVT;
				_detail.Dvt = dataCT.Dvt;

				_detail.Soluongchungtu = (dataCT.KhoiLuongTheoMeTron * dataCT.SoLuongMeTronThucTe) + '';
				_detail.Solo = "";
				_detail.Ghichulohang = "";
				_detail.SoMay = "";
				_detail.NgaySanXat = dataCT.NgaySanXuat;
				_detail.IdNguon = dataCT.Id;
				_detail.NguonPhatSinh = DeNghiNhapKho.optionsLoaiPhieu[4].value;
			
				let indexDetail = this.tmpChiTietDNNK.findIndex(x => x.IdHh == _detail.IdHh 
															&& x.Solo == _detail.Solo
															&& x.SoMay == _detail.SoMay
															&& moment(new Date(x.NgaySanXat)).format('YYYY-MM-DD')
															== moment(new Date(_detail.NgaySanXat)).format('YYYY-MM-DD'));

				if(indexDetail > -1){
					this.tmpChiTietDNNK[indexDetail].Soluongchungtu = '' + 
						(Number(_detail.Soluongchungtu) + Number(this.tmpChiTietDNNK[indexDetail].Soluongchungtu));
					this.tmpChiTietDNNK[indexDetail].Ghichulohang = _detail.Ghichulohang;
				}
				else{
					this.tmpChiTietDNNK.push(_detail);
					this.saveAddedCT.push(this.tmpChiTietDNNK.findIndex(x => x == _detail));
				}

				this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
				this.scrollToBottom();
				this.changeDetectView();
			}

			if(this.data.fromLenhSanXuat){
				;
				this.DNNKItem.isCreateQT = false;
				var dataM = this.data.data;
				this.DNNKForm.controls["LoaiPhieu"].setValue(dataM.LoaiPhieu.toString());
				this.DNNKForm.controls["NgayNhapKho"].setValue(dataM.Ngaynhap);
				this.DNNKForm.controls["PBDeNghi"].setValue(dataM.BoPhanDeNghi.toString());
				this.DNNKForm.controls["Lydonhap"].setValue(dataM.Lydonhap);
				this.tmpChiTietDNNK = [...dataM.listChiTietNhapKho];
				this.scrollToBottom();
				this.changeDetectView();
			}

			if(this.data.fromLenhSanXuatThua){
				this.DNNKItem.isCreateQT = false;
				var dataM = this.data.data;
				this.DNNKForm.controls["LoaiPhieu"].setValue(dataM.LoaiPhieu.toString());
				this.DNNKForm.controls["NgayNhapKho"].setValue(dataM.Ngaynhap);
				this.DNNKForm.controls["PBDeNghi"].setValue(dataM.BoPhanDeNghi.toString());
				this.DNNKForm.controls["Lydonhap"].setValue(dataM.Lydonhap);
				this.tmpChiTietDNNK = [...dataM.listChiTietNhapKho];
				this.scrollToBottom();
				this.changeDetectView();
			}
		}

		this.title = this.getTitle();

        /* Filter list Hang hoa when value change*/
        this.HHForm.get('MaHang').valueChanges.subscribe(newValue=>{
            this.filterId_HH(newValue);
		})

		this.deNghiNhapKhoService.data_import.subscribe(res => {
			if(res != null && res != undefined && res.length > 0){
				res.forEach(element =>{
					const _detail = new DeNghiNhapKhoChiTiet();
					_detail.clear();
					_detail.isError = element.isError;
					_detail.messageError = element.messageError;

					let errorMessageArray = _detail.messageError.split(",");
					if(errorMessageArray != null && errorMessageArray != undefined){
						for(let i = 0; i < errorMessageArray.length; i++){
							switch (i) {
								case 0:{
									if(errorMessageArray[i] == "null"){
										let index = this.listId_HH.findIndex(x => x.MaHH == element.MaHH)
										if(index > -1){
											_detail.IdHh = this.listId_HH[index].Id_HH
											_detail.MaHH = this.listId_HH[index].MaHH;
											_detail.TenHH = this.listId_HH[index].TenHH;
											_detail.QuyCach = this.listId_HH[index].QuyCach;
											_detail.TenDVT = this.listId_HH[index].TenDVT;
											_detail.Dvt = this.listId_HH[index].DVT;
										}
										else{
											_detail.isError = true;
											_detail.MaHH = element.MaHH;
											errorMessageArray[i] = "Không tìm thấy mã hàng tương ứng; ";
										}
									}
									else{
										_detail.isError = true;
										element.MaHH == null ? errorMessageArray[i] = "Mã hàng hóa không được để trống; " : null;
									}
									break;
								}
								case 1:{
									element.Solo == null ? errorMessageArray[i] = "Số lô không được để trống; " 
															: _detail.Solo = element.Solo;
									break;
								}
								case 2:{
									element.Soluongchungtu == null ? errorMessageArray[i] = "Số lượng bị lỗi, vui lòng kiểm tra lại; " 
																	: _detail.Soluongchungtu = element.Soluongchungtu;
									break;
								}
								case 3:{
									_detail.Ghichulohang = element.Ghichulohang
									break;
								}
							}
						}
						_detail.messageError = "";
						errorMessageArray.forEach(elementMessage => {
							if(elementMessage != "null"){
								_detail.messageError += elementMessage;
							}
						})
						if(_detail.messageError[0] == ";")
							_detail.messageError = _detail.messageError.substring(1).trim();
						if(_detail.messageError[_detail.messageError.length - 1] == ";")
							_detail.messageError = _detail.messageError.substring(0, _detail.messageError.length - 1).trim();

						if(!_detail.isError){
							let indexDetail = this.tmpChiTietDNNK.findIndex(x => x.IdHh == _detail.IdHh 
																			&& x.Solo == _detail.Solo);
							if(indexDetail > -1){
								this.tmpChiTietDNNK[indexDetail].Soluongchungtu = '' + (Number(_detail.Soluongchungtu) + Number(this.tmpChiTietDNNK[indexDetail].Soluongchungtu));
							}
							else{
								this.tmpChiTietDNNK.push(_detail);
							}
						}
						else{
							this.tmpChiTietDNNK.push(_detail);						
						}
					}
					else{
						this.layoutUtilsService.showErorr('Lỗi đọc dữ liệu file, vui lòng thử lại');
						return;
					}
				})
				this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
				this.processImport = false;
				this.ImportHHForm.controls['FileDuLieu'].enable();
				this.changeDetectView();
			}
		});

		if(!this.data.fromLenhSanXuat && !this.data.fromLenhSanXuatThua){
			let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị nhập kho', page: '/de-nghi-nhap-kho'}, { title: ((this.DNNKItem.IdDn > 0 && !this.isCopy) ? 'Cập nhật' : 'Thêm mới') + ' đề nghị nhập kho' }];
			this.subheaderService.setBreadcrumbs(breadcrumbs);
		}

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
			this.changeDetectView();
		});

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
    }
    ngOnDestroy() {
		this.clearDataImport();
    }
    /* -----------------------------------------------------------------------*/


    /*----------------- Create Form with appropriate sub forms ---------------*/
    createForm(){
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
        this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
		
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.DNNKItem.Nguoitao = +idUser;

		/*Group các Form */
		this.DNNKForm = this.DNNKFB.group({
			SoPhieu: ['', Validators.required],
			NgayLapPhieu: [new Date(), Validators.required],
			TenNguoiLap: [tenNguoiLap],
			TrangThai: [this.nameState],
			LoaiPhieu: ['', Validators.required],
            PBDeNghi: [this.PBUser.toString(),Validators.required],
            NgayNhapKho: [new Date(), Validators.required],
			BPNhap: [''],
			GiaiDoanHH: [''],
			Lydonhap: [''],
			LyDo: ['', Validators.required],
	
		});
		
		if(this.listState.length > 0){
			this.checkState();
		}
        
		/*Disable các trường dữ liệu không thay đổi */
        this.DNNKForm.controls["SoPhieu"].disable();
        this.DNNKForm.controls["NgayLapPhieu"].disable();
        this.DNNKForm.controls["TenNguoiLap"].disable();
        this.DNNKForm.controls["TrangThai"].disable();
        /*------------------------------------------------------------------*/

		this.HHForm = this.HHFB.group({
			MaHang: ['',Validators.required],
			TenHang: [''],
			QuyCach: [''],
            DVT: [''],
            Solo: ['',Validators.required],
			SoLuong:[DeNghiNhapKho.DEFAULT_NUMBER_VALUE, 
				Validators.compose([Validators.required, 
								Validators.min(0.01),
								Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER)])
            ],
			GhiChu: [''],
			SoMay: [''],
			NgaySanXat: [new Date(),Validators.required],
			Mathung: ['']
		});

        /*Disable các trường dữ liệu không thay đổi */
		this.HHForm.controls["TenHang"].disable();
		this.HHForm.controls["QuyCach"].disable();
		this.HHForm.controls["DVT"].disable();
		/*------------------------------------------------------------------*/

		this.ImportHHForm = this.ImportFB.group({
			FileDuLieu: [''],
		});
		/*------------------------------------------------------------------*/

        this.changeDetectView();
	}
	bindingValueAfterCallAPIDetail(){
		if(this.DNNKItem.IdDn > 0){
			if(!this.isCopy){
				this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
			}
			else{
				this.DNNKItem.IdDn = 0;
				this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
				this.DNNKItem.listChiTietNhapKho.forEach(x => {
					x.IdCtdn = 0;
					x.isDone = false;
					x.DaLapPhieuNhapKho = false;
					x.Nguoikiemtra = 0;
					x.Ngaykiemtra = '';
					x.Quyetdinhlohang = -1;
					x.SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
				})
	
				this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
					if (res.status == 1){
						this.DNNKItem.Sophieu = res.data;
						if(this.DNNKForm != null)
							this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
					}
				});
			}

			this.DNNKForm.controls["NgayLapPhieu"].setValue(this.DNNKItem.Ngaytao);
			this.DNNKForm.controls["TenNguoiLap"].setValue(this.DNNKItem.TenNguoitao);
			this.DNNKForm.controls["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
			this.DNNKForm.controls["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
			this.DNNKForm.controls["BPNhap"].setValue(this.DNNKItem.BoPhanNhap.toString());
			this.DNNKForm.controls["GiaiDoanHH"].setValue(this.DNNKItem.QTSX_GiaiDoan_Id.toString());
			this.DNNKForm.controls["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
			this.DNNKForm.controls["LyDo"].setValue(this.DNNKItem.LyDo);
			this.checkState();
			this.checkPB();

			/*Add dữ liệu chi tiết*/
			if(this.DNNKItem.listChiTietNhapKho.length > 0){
				this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
				this.tmpChiTietDNNK = [];
				for(let i = 0; i < this.listChiTietDNNK.length; i++){
					if(this.listChiTietDNNK[i].SoLuongThucNhap == null){
						this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
					}
					let tmpElement = new DeNghiNhapKhoChiTiet();
					tmpElement.copy(this.listChiTietDNNK[i])
					this.tmpChiTietDNNK.push(tmpElement);
				}
				
				this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
			}
		}
	}
	bindingValueAfterGetDataLenhSanXuat(){
		this.DNNKItem.IdDn = 0;
		this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
		this.DNNKItem.listChiTietNhapKho.forEach(x => {
			x.IdCtdn = 0;
			x.isDone = false;
			x.DaLapPhieuNhapKho = false;
			x.Nguoikiemtra = 0;
			x.Ngaykiemtra = '';
			x.Quyetdinhlohang = -1;
		})

		this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
			if (res.status == 1){
				this.DNNKItem.Sophieu = res.data;
				if(this.DNNKForm != null)
					this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
			}
		});

		this.DNNKForm.controls["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
		this.DNNKForm.controls["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
		this.DNNKForm.controls["BPNhap"].setValue(this.DNNKItem.BoPhanNhap.toString());
		this.DNNKForm.controls["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
		this.checkState();
		this.checkPB();

		/*Add dữ liệu chi tiết*/
		if(this.DNNKItem.listChiTietNhapKho.length > 0){
			this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
			this.tmpChiTietDNNK = [];
			for(let i = 0; i < this.listChiTietDNNK.length; i++){
				if(this.listChiTietDNNK[i].SoLuongThucNhap == null){
					this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
				}
				let tmpElement = new DeNghiNhapKhoChiTiet();
				tmpElement.copy(this.listChiTietDNNK[i])
				this.tmpChiTietDNNK.push(tmpElement);
			}
			
			this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
		}

		localStorage.removeItem("DataDNNKSource");
	}
    getTitle(): string {
		if (this.DNNKItem.IdDn > 0 && !this.isCopy) {
			return `Chỉnh sửa phiếu đề nghị nhập kho`;
		}
		return 'Thêm mới phiếu đề nghị nhập kho';
    }
    /* -----------------------------------------------------------------------*/


    /*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
    /* -----------------------------------------------------------------------*/


    /*------------------------- Hàm lấy danh sách-----------------------------*/
    ListState(){
		this.dungChungService.listState(DeNghiNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.DNNKItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.DNNKForm != null)
					this.DNNKForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}
	
    ListId_HH(){
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if(searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if(searchTmp != ''){
			this.sumRecord = this.listId_HH.filter(ts =>ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts => 
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else{
			this.sumRecord = this.listId_HH.filter(ts => ts.MaHang.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts => 
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}
		
		this.changeDetectView();
	}
	afterSelectHH(value:string){
		this.listId_HH.forEach( element => {
			if(element.Id_HH == +value){
				this.selectId_HH = value;
				this.HHForm.controls["MaHang"].setValue(element.MaHH);
				this.HHForm.controls["MaHang"].disable();
				this.HHForm.controls["TenHang"].setValue(element.TenHH);
				this.HHForm.controls["QuyCach"].setValue(element.QuyCach);
				this.HHForm.controls["DVT"].setValue(element.TenDVT);
				//this.validateInvalidSubForm();
			}
		});
		this.isDisableButton();
	}
	clearSelectHH(event: any){
		this.selectId_HH = '';
		this.HHForm.controls["MaHang"].setValue('');
		this.HHForm.controls["MaHang"].enable();

		this.HHForm.controls["TenHang"].setValue('');
		this.HHForm.controls["QuyCach"].setValue('');
		this.HHForm.controls["DVT"].setValue('');

		this.sumRecord = this.listId_HH.length;
		if(event != null)
			event.stopPropagation();
		this.isDisableButton();
	}
	
	ListPB(){
		this.dungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listPB = res.data;
				this.filteredPB.next(this.listPB.slice());

				var phongban = '';
				this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

				if(this.DNNKItem.IdDn > 0){
					this.listPB.forEach(element => {
						if(element.Id_PB == +this.DNNKItem.BoPhanDeNghi){
							this.PBUser = element.Id_PB.toString();
						}
					})
				}
				else{
					this.listPB.forEach(element => {
						if(element.Id_PB == +phongban){
							this.PBUser = element.Id_PB.toString();
						}
					})
				}
				this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
				this.changeDetectView();
			};
		});
	}
	filterPB() {
		if (!this.listPB) {
			return;
		}
		let search = this.PBFilterCtrl;
		if (!search) {
			this.filteredPB.next(this.listPB.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredPB.next(
			this.listPB.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	checkPB(){
		this.listPB.forEach(element => {
			if(element.Id_PB == this.DNNKItem.BoPhanDeNghi){
				this.PBUser = element.Id_PB.toString();
				if(this.DNNKForm != null)
					this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
			}
		});
	}

	ListBoPhan(){
		this.dungChungService.listBoPhanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBP = res.data;
				this.filteredBP.next(this.listBP.slice());
				this.changeDetectView();
			};
		});
	}
	filterBoPhan() {
		if (!this.listBP) {
			return;
		}
		let search = this.BPFilterCtrl;
		if (!search) {
			this.filteredBP.next(this.listBP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredBP.next(
			this.listBP.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	clearBoPhanNhap(event: any){
		this.DNNKForm.controls["BPNhap"].setValue('');
		event.stopPropagation();
		this.changeDetectView();
	}


	ListGDHH(){
		this.dungChungService.listGiaiDoanHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listGDHH = res.data;
				this.filteredGDHH.next(this.listGDHH.slice());
				this.changeDetectView();
			};
		});
	}
	filterGDHH() {
		if (!this.listGDHH) {
			return;
		}
		let search = this.GDHHFilterCtrl;
		if (!search) {
			this.filteredGDHH.next(this.listGDHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredGDHH.next(
			this.listGDHH.filter(ts =>
				ts.Ten.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	clearGDHH(event: any){
		this.DNNKForm.controls["GiaiDoanHH"].setValue('');
		event.stopPropagation();
		this.changeDetectView();
	}

	ListLoaiPhieu(){
		this.dungChungService.layDanhSachLoaiPhieu(DeNghiNhapKho.DEFAULT_LOAIPHIEU).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {

				this.listLoaiPhieu = res.data;
				this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());
				
				let item = this.listLoaiPhieu.find( x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)
				if(this.data.fromKQPhongCan){
					item = this.listLoaiPhieu.find( x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[4].value)
				}
				if(this.DNNKItem.IdDn > 0){
					item = this.listLoaiPhieu.find( x => x.Id == this.DNNKItem.LoaiPhieu)
				}

				let index = this.listLoaiPhieu.findIndex( x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[3].value)
				if(item != null && this.DNNKForm != null){
					this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
					if(this.data.fromKQPhongCan)
						this.DNNKForm.controls["LoaiPhieu"].disable();
				}
				if(index > -1){
					this.listLoaiPhieu.splice(index, 1);
					this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());
				}
				if(this.isNHSX()){
					this.HHForm.controls["NgaySanXat"].setValidators([Validators.required]);
					this.HHForm.controls['NgaySanXat'].updateValueAndValidity()
				}
				this.changeDetectView();
			};
		});
	}
	filterLoaiPhieu() {
		if (!this.listLoaiPhieu) {
			return;
		}
		let search = this.LoaiPhieuFilterCtrl;
		if (!search) {
			this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredLoaiPhieu.next(
			this.listLoaiPhieu.filter(ts =>
				ts.Ten.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	changeLoaiPhieu(){
		if(this.isNHSX()){
			this.HHForm.controls["NgaySanXat"].setValidators([Validators.required]);
			this.HHForm.controls['NgaySanXat'].updateValueAndValidity()
		}
		else{
			this.HHForm.controls["NgaySanXat"].setValidators([]);
			this.HHForm.controls['NgaySanXat'].updateValueAndValidity()
		}
		this.HHForm.reset();
		this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
		this.HHForm.controls["NgaySanXat"].setValue(new Date())

		this.isDisableButton();
		this.clearSelectHH(null);
		this.changeDetectView();
	}
	isNHSX(){
		let value = +this.DNNKForm.controls["LoaiPhieu"].value;
		let item = this.listLoaiPhieu.find(x => x.Id == value)
		if(item != null)
			return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value || 
					(this.data.fromKQPhongCan && item.Ma == DeNghiNhapKho.optionsLoaiPhieu[4].value);
		return false;
	}
    /* -----------------------------------------------------------------------*/

    
    /*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
    showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength') 
			|| (controls[columnName].value.length > 22 
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21))) 
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DeNghiNhapKho.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
				
			}else{
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");
			
			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event : any, min: number = 0){

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) { 
			event.preventDefault(); 
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) 
			{ return; } 

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			}else{
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet){
		
		if(event.target.value == "")
		{
			event.target.value =  this.f_number(0);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if(event.target.value.toString() == item[columnName].toString())
		{
			event.target.value =  this.f_number(item[columnName]);
			event.target.selectionStart = 0;
			event.target.selectionEnd = 0;
		}

		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

			if(Number(tmpValue) < min) tmpValue = min;

			if(!item[columnName]){
				item[columnName] = tmpValue.toString();
			}

			if(tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1){
				tmpValue = min;
			}
			item[columnName] =tmpValue.toString();
		}
		else{
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
    /* -----------------------------------------------------------------------*/


    /*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
    getFormatDate(v: string = '') {
        if (v != null && v!= undefined && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()){
			this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Handung =  moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
		}
		this.changeDetectView();
	}
    /* -----------------------------------------------------------------------*/


    /*---------------------------- Thao tác trên form ------------------------*/
    isDisableButton(){
		if( this.HHForm.invalid ||
			this.HHForm.controls["TenHang"].value == null || 
			this.HHForm.controls["TenHang"].value == ''){
				this.disableNewButton = true;
		}
		else{
			this.disableNewButton = false;
		}
	}
	isChangeTTPhieu(){

		let isChange = false;
		if(this.DNNKItem.IdDn > 0){

			let item = this.listLoaiPhieu.find( x => x.Id == this.DNNKItem.LoaiPhieu)
			if(this.DNNKForm.controls["LoaiPhieu"].value != item.Id.toString()){
				isChange = true
				return isChange;
			}
			if(+this.DNNKForm.controls["PBDeNghi"].value != this.DNNKItem.BoPhanDeNghi){
				isChange = true
				return isChange;
			}
			if(+this.DNNKForm.controls["BPNhap"].value != this.DNNKItem.BoPhanNhap){
				isChange = true
				return isChange;
			}
			if(+this.DNNKForm.controls["GiaiDoanHH"].value != this.DNNKItem.QTSX_GiaiDoan_Id){
				isChange = true
				return isChange;
			}
			if(moment(new Date(this.DNNKForm.controls["NgayNhapKho"].value)).format('YYYY-MM-DD')
					!= moment(new Date(this.DNNKItem.Ngaynhap)).format('YYYY-MM-DD')){
				isChange = true
				return isChange;
			}
			if(this.DNNKForm.controls["Lydonhap"].value != this.DNNKItem.Lydonhap){
				isChange = true
				return isChange;
			}

			
			let isAllnew = false;
			this.tmpChiTietDNNK.forEach(x => {
				if(x.IdCtdn == 0){
					isAllnew = true;
				}
			})
			if(isAllnew && this.DNNKItem.IdDn > 0)
				return true;

			if(this.DNNKItem.listChiTietNhapKho.length != this.tmpChiTietDNNK.length){
				isChange = true
				return isChange;
			}
		}
		else{
			var phongban = '';
			this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

			let item = this.listLoaiPhieu.find( x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)

			if(moment(new Date(this.DNNKForm.controls["NgayNhapKho"].value)).format('YYYY-MM-DD')
					!= moment(new Date()).format('YYYY-MM-DD')
			|| this.DNNKForm.controls["LoaiPhieu"].value != item.Id.toString()
			|| this.DNNKForm.controls["Lydonhap"].value != null && this.DNNKForm.controls["Lydonhap"].value != ''
			|| this.DNNKForm.controls["PBDeNghi"].value != phongban
			|| ( this.DNNKForm.controls["BPNhap"].value != null && this.DNNKForm.controls["BPNhap"].value != '')
			|| (this.DNNKForm.controls["GiaiDoanHH"].value != null && this.DNNKForm.controls["GiaiDoanHH"].value != '')
			|| this.tmpChiTietDNNK.length > 0){
				isChange = true;
			}
		}
		return isChange;
	}
	back(){
		if(!this.isChangeTTPhieu())
			this.dialogRef.close();
		else{
			const dialogRef = this.layoutUtilsService.POPConfirm('Các thông tin vừa chỉnh sửa sẽ bị mất nếu bạn không lưu lại?');

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.dialogRef.close();
			});
		}
	}
	deleteItem(item: any){
		const index = this.tmpChiTietDNNK.indexOf(item, 0);
		if (index > -1) {
			this.tmpChiTietDNNK.splice(index, 1);
		}
		this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
	}
	clearErrorData(){
		for(let i = 0 ; i < this.tmpChiTietDNNK.length;i++){
			if(this.tmpChiTietDNNK[i].isError){
				this.tmpChiTietDNNK.splice(i, 1);
				i--;
			}
		}
		this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
	}
	checkErrorData(){
		for(let i = 0 ; i < this.tmpChiTietDNNK.length;i++){
			if(this.tmpChiTietDNNK[i].isError){
				return true;
			}
		}
		return false;
	}
    addDetail(){
		const _detail = new DeNghiNhapKhoChiTiet();
		_detail.clear();

		let index = this.listId_HH.findIndex(x => x.Id_HH == +this.selectId_HH)
		if(index > -1){
			_detail.MaHH = this.listId_HH[index].MaHH;
			_detail.TenHH = this.listId_HH[index].TenHH;
			_detail.QuyCach = this.listId_HH[index].QuyCach;
			_detail.TenDVT = this.listId_HH[index].TenDVT;
			_detail.Dvt = this.listId_HH[index].DVT;
		}

		_detail.IdHh = +this.selectId_HH;
		_detail.Soluongchungtu = this.f_number(this.HHForm.controls['SoLuong'].value);
        _detail.Solo = this.HHForm.controls["Solo"].value;
		_detail.Ghichulohang = this.HHForm.controls["GhiChu"].value;
		_detail.SoMay = this.HHForm.controls["SoMay"].value;
		_detail.MaThung = this.HHForm.controls["MaThung"].value;
		if(this.HHForm.controls["NgaySanXat"].value != null && this.HHForm.controls["NgaySanXat"].value != '')
			_detail.NgaySanXat = moment(new Date(this.HHForm.controls["NgaySanXat"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		
		const message = `Thông tin hàng đề nghị nhập kho đã được thêm.`;
		this.layoutUtilsService.showInfo(message);
	
		this.HHForm.reset();
		this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
		this.HHForm.controls["MaHang"].enable(); //Open field when reset
		this.HHForm.controls["NgaySanXat"].setValue(new Date());

		this.selectId_HH = '';
		this.filteredId_HH.next(this.listId_HH.slice());
		
		let indexDetail = this.tmpChiTietDNNK.findIndex(x => x.IdHh == _detail.IdHh 
													&& x.Solo == _detail.Solo
													&& x.SoMay == _detail.SoMay
													&& moment(new Date(x.NgaySanXat)).format('YYYY-MM-DD')
													== moment(new Date(_detail.NgaySanXat)).format('YYYY-MM-DD'));

		if(indexDetail > -1){
			this.tmpChiTietDNNK[indexDetail].Soluongchungtu = '' + 
				(Number(_detail.Soluongchungtu) + Number(this.tmpChiTietDNNK[indexDetail].Soluongchungtu));
			this.tmpChiTietDNNK[indexDetail].Ghichulohang = _detail.Ghichulohang;
		}
		else{
			this.tmpChiTietDNNK.push(_detail);
			this.saveAddedCT.push(this.tmpChiTietDNNK.findIndex(x => x == _detail));
		}

		this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
		this.disableNewButton = true;
		this.scrollToBottom();
		this.changeDetectView();
	}
    onSubmit(type: number) {
		const controls = this.DNNKForm.controls;

		if (this.DNNKForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			document.getElementById('dialog-form').scrollTo({ top: 0, behavior: 'smooth' });
			return false;
		}

		if (this.tmpChiTietDNNK.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng thêm thông tin hàng đề nghị nhập kho');
			this.scrollToBottom();
			return null;
		}

		for(let i = 0; i < this.tmpChiTietDNNK.length; i++){
			if(!this.tmpChiTietDNNK[i].isError){
				if(Number(this.tmpChiTietDNNK[i].Soluongchungtu) <= 0 ){
					this.layoutUtilsService.showErorr('Số lượng của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được <= 0');
					this.scrollToBottom();
					return null;
				}
				else if(this.tmpChiTietDNNK[i].Solo == null || this.tmpChiTietDNNK[i].Solo == undefined || this.tmpChiTietDNNK[i].Solo == '' || this.tmpChiTietDNNK[i].Solo.trim() == ''){
					this.layoutUtilsService.showErorr('Số lô của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được để trống');
					this.scrollToBottom();
					return null;
				}
		
				else if(this.isNHSX() && (this.tmpChiTietDNNK[i].NgaySanXat == null || this.tmpChiTietDNNK[i].NgaySanXat == undefined || this.tmpChiTietDNNK[i].NgaySanXat == '')){
					this.layoutUtilsService.showErorr('Ngày sản xuất của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được để trống với loại phiếu nhập hàng sản xuất');
					this.scrollToBottom();
					return null;
				}
			}
		}

		const _result = new DeNghiNhapKho();
        _result.clear();
		_result.Sophieu = controls["SoPhieu"].value;
		_result.Ngaynhap = moment(new Date(controls["NgayNhapKho"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
		_result.Ngaytao = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS'); // tmp Value but insert today in API
		_result.Tinhtrang =  DeNghiNhapKho.optionsTinhTrang[0].value;
		_result.LoaiPhieu = +controls["LoaiPhieu"].value;
		_result.BoPhanDeNghi = +controls["PBDeNghi"].value;
		_result.BoPhanNhap = +controls["BPNhap"].value;
		_result.QTSX_GiaiDoan_Id = +controls["GiaiDoanHH"].value;
		_result.Lydonhap = controls["Lydonhap"].value;
		_result.isCreateQT = this.DNNKItem.isCreateQT;
		if(type == 1 || type == 2){
			_result.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[4].value;
		}

		_result.listChiTietNhapKho = this.tmpChiTietDNNK;

		if(type == 1 || type == 2){
			const dialogRef = this.layoutUtilsService.POP02(_result.Sophieu);
			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				if (this.DNNKItem.IdDn > 0) {
					_result.IdDn = this.DNNKItem.IdDn;
					_result.BoPhanDeNghi = this.DNNKItem.BoPhanDeNghi;
					this.update(_result,type);
					return;
				}
				this.add(_result,type);
			});
		}
		else{
			if (this.DNNKItem.IdDn > 0) {
				_result.IdDn = this.DNNKItem.IdDn;
				this.update(_result,type);
				return;
			}
			this.add(_result,type);
		}
    }
    update(item: DeNghiNhapKho, withBack: number) {
		this.deNghiNhapKhoService.updatWithDetail(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Phiếu đề nghị nhập kho cập nhật thành công`;
				this.layoutUtilsService.showInfo(message);
				
				let index = this.saveAdded.findIndex(x => x == res.data.IdDn);
				if(index == -1)
					this.saveAdded.push(res.data.IdDn);
				this.deNghiNhapKhoService.dataNew$.next(this.saveAdded)

				if(withBack == 1){
					this.dialogRef.close();
				}
				else{
					this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
                    this.clearDataImport();
                    
					if(withBack == 2){
						this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(resNextSP => {
							if (resNextSP.status == 1) {

                                this.DNNKForm.reset();
                                
								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
								
								var phongban = '';
								this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

								this.DNNKForm.controls["SoPhieu"].setValue(resNextSP.data);
								this.DNNKForm.controls["NgayLapPhieu"].setValue(new Date());
								this.DNNKForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
                                this.DNNKForm.controls["NgayNhapKho"].setValue(new Date());
                                this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
								let item = this.listLoaiPhieu.find( x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)
								if(item != null && this.DNNKForm != null){
									this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
								}
								
                                this.listPB.forEach(element => {
									if(element.Id_PB == +phongban){
										this.PBUser = element.Id_PB.toString();
									}
								})
								this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser);

                                /*Disable các trường dữ liệu không thay đổi */
								this.DNNKForm.controls["SoPhieu"].disable();
								this.DNNKForm.controls["NgayLapPhieu"].disable();
								this.DNNKForm.controls["TenNguoiLap"].disable();
								this.DNNKForm.controls["TrangThai"].disable();
                                
                                this.HHForm.reset();
                                this.HHForm.controls["MaHang"].enable();
								this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
								this.HHForm.controls["NgaySanXat"].setValue(new Date());
								this.sumRecord = this.listId_HH.length;
                                this.ImportHHForm.reset();

								this.listChiTietDNNK = [];
								this.tmpChiTietDNNK = [];
								this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];

								this.DNNKItem.IdDn = 0;
								this.DNNKItem.Sophieu = resNextSP.data;
								this.title = this.getTitle();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}

					else if(withBack == 3){
						this.deNghiNhapKhoService.getItemById(this.DNNKItem.IdDn).subscribe(res => {
							if (res.status == 1) {
								this.DNNKItem = res.data;
								if(this.DNNKItem.listChiTietNhapKho.length > 0){
									this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
									this.tmpChiTietDNNK = [];
									for(let i = 0; i < this.listChiTietDNNK.length; i++){
										if(this.listChiTietDNNK[i].SoLuongThucNhap == null){
											this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
										}
										let tmpElement = new DeNghiNhapKhoChiTiet();
										tmpElement.copy(this.listChiTietDNNK[i])
										this.tmpChiTietDNNK.push(tmpElement);
									}
									
									this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
								}
								this.changeDetectView();
							}
						});
						this.isCopy = false;
					}
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	add(item: DeNghiNhapKho, withBack: number){
		this.deNghiNhapKhoService.add(item).subscribe(res => {
			if (res.status == 1) {
				const message = `Phiếu đề nghị nhập kho mới đã được thêm.`;
				this.layoutUtilsService.showInfo(message);
	
				let index = this.saveAdded.findIndex(x => x == res.data.IdDn);
				if(index == -1)
					this.saveAdded.push(res.data.IdDn);
				this.deNghiNhapKhoService.dataNew$.next(this.saveAdded)

				res.data.listChiTietNhapKho.forEach(element =>{
					let index = this.tmpChiTietDNNK.findIndex(x => x.IdCtdn == element.IdCtdn);
					if(index > -1){
						this.tmpChiTietDNNK[index].IdLo = element.IdLo;
					}
				})

				if(withBack == 1){
					this.dialogRef.close();
				}
				else{

					this.selectId_HH = '';
					this.filteredId_HH.next(this.listId_HH.slice());
					this.clearDataImport();

					if(withBack == 2){
						this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
							if (res.status == 1) {

								this.DNNKForm.reset();
                                
								var tenNguoiLap = '';
								this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
								
								var phongban = '';
								this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
								
								this.DNNKForm.controls["SoPhieu"].setValue(res.data);
								this.DNNKForm.controls["NgayLapPhieu"].setValue(new Date());
								this.DNNKForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
                                this.DNNKForm.controls["NgayNhapKho"].setValue(new Date());
                                this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
								let item = this.listLoaiPhieu.find( x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)
								if(item != null && this.DNNKForm != null){
									this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
								}
								
                                this.listPB.forEach(element => {
									if(element.Id_PB == +phongban){
										this.PBUser = element.Id_PB.toString();
									}
								})
								this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser);
                                
                                /*Disable các trường dữ liệu không thay đổi */
								this.DNNKForm.controls["SoPhieu"].disable();
								this.DNNKForm.controls["NgayLapPhieu"].disable();
								this.DNNKForm.controls["TenNguoiLap"].disable();
								this.DNNKForm.controls["TrangThai"].disable();

                                this.HHForm.reset();
                                this.HHForm.controls["MaHang"].enable();
                                this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
								this.HHForm.controls["NgaySanXat"].setValue(new Date());
								this.sumRecord = this.listId_HH.length;
                                this.ImportHHForm.reset();

								this.listChiTietDNNK = [];
								this.tmpChiTietDNNK = [];
								this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];

								this.DNNKItem.Sophieu = res.data;
								this.changeDetectView();
							}
							else {
								const message = `Lỗi lấy số phiếu tiếp theo`;
								this.layoutUtilsService.showErorr(message);
							}
						});
					}
					else if(withBack == 3){
                        this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
						this.DNNKItem.IdDn = res.data.IdDn;
						this.deNghiNhapKhoService.getItemById(this.DNNKItem.IdDn).subscribe(res => {
							if (res.status == 1) {
								this.DNNKItem = res.data;
								if(this.DNNKItem.listChiTietNhapKho.length > 0){
									this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
									this.tmpChiTietDNNK = [];
									for(let i = 0; i < this.listChiTietDNNK.length; i++){
										if(this.listChiTietDNNK[i].SoLuongThucNhap == null){
											this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
										}
										let tmpElement = new DeNghiNhapKhoChiTiet();
										tmpElement.copy(this.listChiTietDNNK[i])
										this.tmpChiTietDNNK.push(tmpElement);
									}
									
									this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
								}
								this.changeDetectView();
							}
						});
						this.isCopy = false;
					}
					this.title = this.getTitle();
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	openHistoryDialog(item: DeNghiNhapKhoChiTiet){
		const dialogRef = this.dialog.open(DNNKLSNhapKhoDialogComponent, {
			data: {
				data: item.IdCtdn,
				MaHH: item.MaHH,
				TenHH: item.TenHH
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}
    /* -----------------------------------------------------------------------*/


    /*---------------------- Import file dữ liệu hàng hóa --------------------*/
    selectFile() {
		let el: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
		el.click();
	}
	FileSelected(evt: any) {
		if (evt.target.files && evt.target.files.length) {
			let file = evt.target.files[0];
			let fileName = file.name;
			var res = fileName.match(/.xlsx$/g);
			if (res) {
				if (!res["includes"]('.xlsx')) {
					this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
					return;
				}
				else {
					this.ImportHHForm.controls['FileDuLieu'].patchValue(fileName);
					this.processImport = true;
					this.changeDetectView();
					this.Importfile();
				}
			}
			else {
				this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
				return;
			}
		}
		else {//Không có file
			this.ImportHHForm.controls['FileDuLieu'].patchValue('');
		}
		evt.target.type = 'text';
		evt.target.type = 'file';
	}
	checkDataIsValid(): boolean {
		let p = document.getElementById("fileUploadExcel");
		return this.ImportHHForm.controls['FileDuLieu'] && this.ImportHHForm.controls['FileDuLieu'].valid && (p ? (p["type"] == 'file' ? p["files"]["length"] > 0 : false) : false);
	}
	Importfile() {
		let el: any = this.fileUploadImport.nativeElement;
		var service = this.deNghiNhapKhoService;

		for (var idx = 0; idx < el.files.length; idx++) {

			var extension = el.files[idx].name.split('.').pop();
			var fileName = el.files[idx].name.substring(0,el.files[idx].name.indexOf(extension) - 1);

			let reader = new FileReader();
			reader.readAsDataURL(el.files[idx]);

			reader.onload = function () {
				let base64Str = reader.result as String;
				var metaIdx = base64Str.indexOf(';base64,');
				base64Str = base64Str.substr(metaIdx + 8);

				var data = {
					fileName: fileName,
					base64: base64Str,
					extension: extension
				};

				service.lastFileUpload$.next(data);
				service.uploadFileImport(data).subscribe(res => {
					if (res && res.status == 1) {
						service.data_import.next(res.data);
					}
					else {
						service.lastFilterDSExcel$.next([]);
						service.lastFilterInfoExcel$.next(undefined);
						return;
					}
				});
			};
		}
	}
	ImportFileMau() {
		let linkdownload = this.deNghiNhapKhoService.downloadTemplate();
		window.open(linkdownload);
	}
	clearDataImport(){
		this.deNghiNhapKhoService.data_import.next([]);
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	timKiemNangCao(){
		this.openTimKiemNangCao = true;
		
		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw : this.focusDetail.first.nativeElement.value
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			}
			else{
				if (!res.isChange) {
					return;
				}
				if(res.dataAdd.length != 0){
					this.afterSelectHH(res.dataAdd.toString())
				}
			}
		});
	}
	tabChange(event: MatTabChangeEvent){
		if(event.index == 0)
			this.flagTab = 0;
		else if(event.index == 1)
			this.flagTab = 1;
		this.clearDataImport();
		this.changeDetectView();
    }
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom(){
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 200);
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
        if (event.key == "Escape") {
		}
		else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_CLOSE.KeyCombine.keycode) {
			this.onSubmit(1);
		}
		else if(event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode){
			this.onSubmit(2);
		}
		else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode) {
			this.onSubmit(3);
		}
		this.changeDetectView();
	}
	/* -----------------------------------------------------------------------*/
}
